import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { ProjetoMoedaService } from '../services/projeto-moeda.service';

@Injectable({
  providedIn: 'root',
})
export class ProjetoMoedaResolver implements Resolve<boolean> {
  constructor(private service: ProjetoMoedaService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.id);
  }
}
